<div class="regions" [class.is-dragging]="isDragging" #regionsContainer>
    <div class="region region-top" [style.flex]="'0 0 ' + topSectionPercentage() + '%'">
      <div class="region-header">
        <div class="region-tabs">
          <div data-test-id="todo-tab" class="region-tab-link" (click)="selectTab('todo')" [ngClass]="{active: activeTab == 'todo'}">
            <div class="bullet bullet-2"></div><span>To Do</span>
          </div>
          <div data-test-id="activity-tab" class="region-tab-link" (click)="selectTab('activity')" [ngClass]="{active: activeTab == 'activity'}">
            <div class="bullet bullet-15"></div><span>Activity</span>
          </div>
        </div>
      </div>
      <div class="region-body">
        <div class="overflow-shadow-y height-full" #notificationsScrollTarget>
          <div class="overflow-shadow-inner height-full" #notificationsScrollContainer (scroll)="scrollShadow(notificationsScrollContainer, notificationsScrollTarget)">
            <div class="notifications-body panel-content">
              <table data-test-id="notifications-table" class="table table-airy table-hover mb-1" *ngIf="(notificationsByCategory[activeTab] ?? []).length">
                <tbody>
                  <tr ycn-notifications-menu-list-item *ngFor="let notification of notificationsByCategory[activeTab]"
                      [notification]="notification" [ngClass]="{'notification-new': !notification.read }"
                      (removeNotification)="removeNotification($event)"
                      (notificationRead)="markNotificationRead($event)">
                  </tr>
                </tbody>
              </table>
              <div data-test-id="notifications-empty-state" class="notifications-empty" *ngIf="!(notificationsByCategory[activeTab] ?? []).length">No new notifications.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="region-drawer"
         (pointerdown)="onPointerDown($event)"
         (pointermove)="onPointerMove($event)"
         (pointerup)="onPointerUp($event)"></div>
    <div class="region region-bottom" [style.flex]="'1 1 auto'">
      <div class="region-header border-b border-color-gray-80 pl-12 pr-12">
        <div class="d-flex justify-content-between align-items-center pt-12 pb-12">
          <a class="text-bold text-underline" [href]="reportHistoryUrl" tooltip="View All Report History" tooltip-placement="right">Report History</a>
        </div>
      </div>
      <div class="region-body">
        <div class="overflow-shadow-y height-full" #reportsScrollTarget>
          <div class="overflow-shadow-inner height-full" #reportsScrollContainer (scroll)="scrollShadow(reportsScrollContainer, reportsScrollTarget)">
            @if( reports.length ) {
              <div class="notifications-body panel-content">
                <table class="table table-airy table-hover mb-1">
                  <tbody>
                    @for(report of reports; track report.id) {
                      <tr ycn-notifications-menu-report-history-item [report]="report"></tr>
                    }
                  </tbody>
                </table>
              </div>
            } @else if (!loadingReports) {
              <div class="notifications-empty">No recent downloads. <br> Run a report to see it here.<a class="text-underline mt-2" [href]="reportHistoryUrl">View all Report History</a></div>
            }
          </div>
        </div>
      </div>
    </div>
</div>
